export default __webpack_public_path__ + "static/media/tiktok-hero.d4e2643c.svg";